import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";

import * as css from "styles/CssVariables.js";
import { BUNNYNET_VIDEO_THUMBNAIL_DOMAIN } from "constants";

import ButtonPrimary from "components/buttons/ButtonPrimary";
import ButtonPrimarySmall from "components/buttons/ButtonPrimarySmall";
import ButtonPrimarySmallIcon from "components/buttons/ButtonPrimarySmallIcon";

import blockIcon from "assets/img/icons/icons8-unavailable.svg";
import plusIcon from "assets/img/icons/plus-sign.svg";
import plusWhiteIcon from "assets/img/icons/plus-sign-white.svg";

const VideoSelection = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_LARGE};
`;

const TopPart = styled.div`
  width: 100%;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN_MEDIUM};
`;

const InfoText = styled.div`
  width: 100%;
  margin-top: 45px;
`;

const FileList = styled.div`
  display: flex;
  flex-direction: column;
`;

const File = styled.div`
  padding: 5px;
  display: flex;
  align-items: center;
  gap: 10px;

  transition: 0.2s;

  border-radius: 10px;

  &:hover {
    cursor: pointer;
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

const FileThumbnail = styled.div`
  width: 60px;
  min-width: 60px;
  height: 48px;

  background-color: rgba(238, 229, 233, 0.5);

  border: 1px solid rgba(238, 229, 233, 0.5);
  border-radius: 10px;

  overflow: hidden;

  display: flex;
  align-items: center;
  justify-content: center;
`;

const Thumbnail = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

const FileName = styled.div`
  max-width: 360px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const CloseButtonWrap = styled.div`
  margin-top: ${css.VERTICAL_BOX_MARGIN_LARGE};

  display: flex;
`;

const ManageButtonWrap = styled.div`
  display: flex;
`;

const NoResults = styled.div`
  width: 100%;
  height: 100px;
  margin-top: 60px;

  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const NoResultsIcon = styled.div`
  width: 32px;
  min-width: 32px;
  height: 32px;
`;

const NoResultsText = styled.div``;

const NoResultButtonWrap = styled(Link)`
  margin-top: ${css.VERTICAL_BOX_MARGIN};

  text-decoration: none;
`;

export default ({ data, closeVideoSelection, onVideoSelect }) => {
  const navigate = useNavigate();

  const activeMedia = data.mediaData.filter(
    (media) => media.status === "active"
  );

  const list = activeMedia.map((video) => {
    const thumbnailUrl =
      BUNNYNET_VIDEO_THUMBNAIL_DOMAIN + "/" + video.video_id + "/thumbnail.jpg";

    return (
      <File id={video.id} onClick={() => onVideoSelect(video.video_id)}>
        <FileThumbnail>
          <Thumbnail src={thumbnailUrl} />
        </FileThumbnail>
        <FileName>{video.original_name}</FileName>
      </File>
    );
  });

  return (
    <VideoSelection>
      <TopPart>
        {list.length !== 0 && (
          <>
            <InfoText>Select the video you want to use in your post:</InfoText>
            <FileList>{list}</FileList>

            <ManageButtonWrap>
              <ButtonPrimarySmall onClick={() => navigate("/ad-plan")}>
                Manage Your Videos
              </ButtonPrimarySmall>
            </ManageButtonWrap>
          </>
        )}
        {list.length === 0 && (
          <NoResults>
            <NoResultsIcon>
              <img src={blockIcon} style={{ width: "100%" }} />
            </NoResultsIcon>
            <NoResultsText>You don't have any videos.</NoResultsText>
            <NoResultButtonWrap to="/ad-plan">
              <ButtonPrimarySmallIcon icon={plusIcon} iconHover={plusWhiteIcon}>
                Upload Video
              </ButtonPrimarySmallIcon>
            </NoResultButtonWrap>
          </NoResults>
        )}
      </TopPart>
      <CloseButtonWrap>
        <ButtonPrimary onClick={closeVideoSelection}>Close</ButtonPrimary>
      </CloseButtonWrap>
    </VideoSelection>
  );
};
